<template>
  <div>
    <role-table :tableData="wbData" :storeType="storeType"></role-table>
  </div>
</template>

<script>
import RoleTable from '../../components/RoleTable'
export default {
  name: 'WbAuth',
  props: {
    wbData: Array
  },
  data() {
    return {
      // tableData: [],
      storeType: 'setCurAddWbAuthData'
    }
  },
  computed: {
    /* tableData() {
      return JSON.parse(JSON.stringify(this.wbData))
    } */
  },
  components: {
    RoleTable
  },
  mounted() {
  },
  methods: {
    /* acceptWbChange(changeData) {
      this.$store.commit('role/setCurAddWbAuthData', changeData)
    } */
  }
}
</script>
